// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-log-dialog {
    min-width: 80vw;
    max-width: 95vw;
}

.table-wrapper {
    overflow-x: auto;
}

.table-wrapper table {
    width: 100%;
    min-width: 800px;
}

.table th:nth-child(3), 
.table td:nth-child(3) {
    width: 40%;
    min-width: 300px;
    max-width: none;
    white-space: normal;
    word-wrap: break-word;
}

.table th:nth-child(1), 
.table td:nth-child(1) {
    width: 20%;
    min-width: 150px;
}

.table th:nth-child(2), 
.table td:nth-child(2) {
    width: 20%;
    min-width: 120px;
}

.table th,
.table td {
    vertical-align: middle;
    text-align: center;
}

.table th p,
.table td {
    vertical-align: middle;
}

.table td p {
    margin: 0;
    line-height: 1.4;
    vertical-align: middle;
}

.changes-column {
    font-size: 0.9em;
    line-height: 1.3;
}

.dropdown-container {
    position: relative;
    display: inline-block;
}

.dropdown-toggle {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 0.85em;
    cursor: pointer;
    color: #495057;
    transition: all 0.2s ease;
}

.dropdown-toggle:hover {
    background: #e9ecef;
    border-color: #adb5bd;
}

.dropdown-toggle.open {
    background: #007bff;
    color: white;
    border-color: #007bff;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 200px;
    max-width: 400px;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    max-height: 200px;
    overflow-y: auto;
}

.dropdown-item {
    padding: 6px 12px;
    font-size: 0.8em;
    border-bottom: 1px solid #f8f9fa;
    color: #495057;
    line-height: 1.3;
}

.dropdown-item:last-child {
    border-bottom: none;
}

.dropdown-item:hover {
    background: #f8f9fa;
}

/* Row hover and cursor styles */
.table tbody tr {
    transition: background-color 0.2s ease;
}

.table tbody tr.clickable {
    cursor: pointer;
}

.table tbody tr.clickable:hover {
    background-color: #f8f9fa;
    color: #495057;
}

.table tbody tr.non-clickable {
    cursor: default;
    opacity: 0.7;
}

.table tbody tr[title] {
    position: relative;
}

/* Pagination controls */
.pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin: 15px 0;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 4px;
}

.pagination-controls button {
    background: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s ease;
}

.pagination-controls button:hover:not(:disabled) {
    background: #0056b3;
}

.pagination-controls button:disabled {
    background: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

.pagination-controls span {
    font-size: 0.9em;
    color: #495057;
    font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/dialogs/sem-audit-log/sem-audit-log.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".audit-log-dialog {\r\n    min-width: 80vw;\r\n    max-width: 95vw;\r\n}\r\n\r\n.table-wrapper {\r\n    overflow-x: auto;\r\n}\r\n\r\n.table-wrapper table {\r\n    width: 100%;\r\n    min-width: 800px;\r\n}\r\n\r\n.table th:nth-child(3), \r\n.table td:nth-child(3) {\r\n    width: 40%;\r\n    min-width: 300px;\r\n    max-width: none;\r\n    white-space: normal;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.table th:nth-child(1), \r\n.table td:nth-child(1) {\r\n    width: 20%;\r\n    min-width: 150px;\r\n}\r\n\r\n.table th:nth-child(2), \r\n.table td:nth-child(2) {\r\n    width: 20%;\r\n    min-width: 120px;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\n.table th p,\r\n.table td {\r\n    vertical-align: middle;\r\n}\r\n\r\n.table td p {\r\n    margin: 0;\r\n    line-height: 1.4;\r\n    vertical-align: middle;\r\n}\r\n\r\n.changes-column {\r\n    font-size: 0.9em;\r\n    line-height: 1.3;\r\n}\r\n\r\n.dropdown-container {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.dropdown-toggle {\r\n    background: #f8f9fa;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    padding: 4px 8px;\r\n    font-size: 0.85em;\r\n    cursor: pointer;\r\n    color: #495057;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.dropdown-toggle:hover {\r\n    background: #e9ecef;\r\n    border-color: #adb5bd;\r\n}\r\n\r\n.dropdown-toggle.open {\r\n    background: #007bff;\r\n    color: white;\r\n    border-color: #007bff;\r\n}\r\n\r\n.dropdown-menu {\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    z-index: 1000;\r\n    min-width: 200px;\r\n    max-width: 400px;\r\n    background: white;\r\n    border: 1px solid #dee2e6;\r\n    border-radius: 4px;\r\n    box-shadow: 0 2px 10px rgba(0,0,0,0.1);\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.dropdown-item {\r\n    padding: 6px 12px;\r\n    font-size: 0.8em;\r\n    border-bottom: 1px solid #f8f9fa;\r\n    color: #495057;\r\n    line-height: 1.3;\r\n}\r\n\r\n.dropdown-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.dropdown-item:hover {\r\n    background: #f8f9fa;\r\n}\r\n\r\n/* Row hover and cursor styles */\r\n.table tbody tr {\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.table tbody tr.clickable {\r\n    cursor: pointer;\r\n}\r\n\r\n.table tbody tr.clickable:hover {\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n}\r\n\r\n.table tbody tr.non-clickable {\r\n    cursor: default;\r\n    opacity: 0.7;\r\n}\r\n\r\n.table tbody tr[title] {\r\n    position: relative;\r\n}\r\n\r\n/* Pagination controls */\r\n.pagination-controls {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin: 15px 0;\r\n    padding: 10px;\r\n    background: #f8f9fa;\r\n    border-radius: 4px;\r\n}\r\n\r\n.pagination-controls button {\r\n    background: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    padding: 8px 12px;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.pagination-controls button:hover:not(:disabled) {\r\n    background: #0056b3;\r\n}\r\n\r\n.pagination-controls button:disabled {\r\n    background: #6c757d;\r\n    cursor: not-allowed;\r\n    opacity: 0.6;\r\n}\r\n\r\n.pagination-controls span {\r\n    font-size: 0.9em;\r\n    color: #495057;\r\n    font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
